function calculateTotal(item, key) {
  return +item[key] * (+item.quantity ?? 1);
}

export function handleTotal(selectedPackages, summaryTotal) {
  if (selectedPackages.length < 1) {
    return summaryTotal;
  }
  let newTotal = summaryTotal;
  selectedPackages &&
    selectedPackages.forEach(item => {
      newTotal += calculateTotal(item, 'amount');
    });
  return newTotal;
}

export function handleTaxes(taxesAndFees, parkingFee, sustainabilityFee, resortFee, selectedPackages) {
  let newTaxesTotal = taxesAndFees;
  if (parkingFee > 0) {
    newTaxesTotal -= parkingFee;
  }
  if (sustainabilityFee > 0) {
    newTaxesTotal -= sustainabilityFee;
  }
  if (resortFee > 0) {
    newTaxesTotal -= resortFee;
  }
  if (selectedPackages.length > 0) {
    selectedPackages.forEach(item => {
      newTaxesTotal += calculateTotal(item, 'tax');
    });
  }

  return newTaxesTotal;
}

export function handlePackagesTaxes(selectedPackages) {
  let packagesTaxesTotal = 0;

  if (selectedPackages.length > 0) {
    selectedPackages.forEach(item => {
      packagesTaxesTotal += calculateTotal(item, 'tax');
    });
  }
  return packagesTaxesTotal;
}

export function handlePackagesTotalWithTax(selectedPackages) {
  let total = 0;

  if (selectedPackages.length > 0) {
    selectedPackages.forEach(item => {
      total += calculateTotal(item, 'amount');
    });

    selectedPackages.forEach(item => {
      total += calculateTotal(item, 'tax');
    });
  }

  return total;
}
